export default "__VITE_ASSET__il3vridD__"